import styled from 'styled-components';

export const IntegrationPageHeroDIV = styled.div`
  position: relative;
  text-align: center;
  overflow: hidden;
  padding: var(--SiteNav--height) 0 0;

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    background: linear-gradient(180deg, rgba(var(--color--clay-200-rgb)), rgba(var(--color--clay-200-rgb), 0));
  }

  /* Brush illustration */
  .brush.gatsby-image-wrapper {
    position: absolute !important;
    top: 0;
    right: 0;
    width: 100%;
    max-width: 764px;
  }

  .back-link {
    align-items: center;
    color: var(--color--text-light);
    display: flex;
    gap: 4px;
    justify-content: center;
    margin: var(--spacing--S) auto var(--spacing--M);
    position: relative;
    width: fit-content;
    z-index: 2;
  }

  h1 {
    position: relative;
    z-index: 1;
    margin: 0 auto var(--spacing--S);
    max-width: max(837px, calc((var(--container-width) / 12 * 8) - (var(--spacing--M) * 4 / 12)));
    text-wrap: balance;
  }

  p {
    color: var(--color--charcoal-700);
  }

  figure {
    position: relative;
    z-index: 0;
    display: flex;
    justify-content: center;
    margin: 0 0 var(--spacing--XS);
    height: 180px;

    .ImageAboveFold {
      &:first-child {
        position: absolute !important;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 458px;
      }

      &:last-child {
        position: absolute !important;
        top: 46%;
        left: 49.5%;
        width: 100%;
        max-width: 70px;
        transform: translate(-50%, -50%);

        &.is-featured {
          max-width: 148px;
        }
      }
    }
  }
`;
